import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getZoneParams, setZoneParams } from '@blade-sxp/account/api/params-setting';
let default_1 = class extends Vue {
    loading = false;
    fromData = { time: undefined };
    response = {};
    rules = {
        time: [{
                required: true,
                trigger: blur,
                message: this.$t('inputError'),
            }],
    };
    handleSubmit() {
        const form = this.$refs.closeTimeForm;
        form.validate((valid) => {
            if (valid) {
                this.loading = true;
                const req = { colorList: this.response.colorList, zoneResetTime: { resetTime: this.fromData.time } };
                setZoneParams(req).then(resp => {
                    this.$message({ type: 'success', message: resp?.data?.message || '' });
                }).catch(error => {
                    this.$message({ type: 'error', message: error });
                }).finally(() => {
                    this.loading = false;
                });
            }
        });
    }
    mounted() {
        getZoneParams().then((resp) => {
            this.response = resp.data?.data || {};
            this.fromData.time = this.response?.zoneResetTime?.resetTime || undefined;
        }).catch(error => {
            this.$message({ type: 'error', message: error });
        });
    }
};
default_1 = __decorate([
    Component({
        name: 'CloseTime',
        i18n: {
            messages: {
                zh: {
                    closeTime: '营业结束时间：',
                    tip: '选择时间',
                    submit: '提交',
                    inputError: '请选择',
                    placeholder: '请输入营业结束时间',
                },
                'en-us': {
                    closeTime: 'Closing time：',
                    tip: 'Select time',
                    submit: 'Submit',
                    inputError: 'Please select the closing time',
                    placeholder: 'Please select',
                },
            },
        },
    })
], default_1);
export default default_1;
